<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router'
import BaseInput from '@/components/ui/BaseInput.vue';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useServiceStore } from '@/stores/serviceStore';
import { useRequestsStore } from '@/stores/storeRequests';

const storeField = useFieldsStore();
const storeService = useServiceStore();
const storeRequests = useRequestsStore();

const router = useRouter()

// const name = ref('');
// const lastName = ref('');
// const birthday = ref('');
// const email = ref('');

// watch(() => storeRequests.userData, () => {
// 	name.value = storeRequests.userData?.first_name;
// 	lastName.value = storeRequests.userData?.last_name;
// 	birthday.value = storeRequests.userData?.birthday;
// 	email.value = storeRequests.userData?.email;
// })




const nextSreen = async () => {
    await storeRequests.userInfoChnage();
    if(!storeRequests.responseOk) return;
    storeService.goToScreen(storeService.screens.services)
    router.push({ hash: `#${storeService.screens.services}`})
    storeRequests.responseOk = null
}

const previousSreen = () => {
    storeService.goToScreen(storeService.screens.authSms)
    storeRequests.responseError = null
    router.push({ hash: `#${storeService.screens.authSms}`})
}

onMounted(() => {
    storeService.hideScreenLoader()
})
</script>
<template>
    <div class="container">
        <div class="services-container">
            <button class="services-btn-back" @click="previousSreen">
                <svg width='24' height='24'><use href='#back_icon'></use></svg>
                <span>Назад</span>
            </button>
            <h2 class="service-title">Уточнение данных</h2>

            <div class="services-form">
                <div class="form">                    
                    <div class="form__row">
                        <BaseInput 
                            :required="true"
                            type="text" 
                            placeholder="Имя"
                            state-key="firstName"                             
                        >
                            Ваше имя
                        </BaseInput>
                        <BaseInput 
                            type="text" 
                            placeholder="Фамилия"
                            state-key="lastName"                             
                        >
                            Фамилия
                        </BaseInput>
                        {{ storeField.fields.birthday.title }}
                        <BaseInput 
                            type="date" 
                            placeholder="Дата рождения"
                            state-key="birthday"                       
                        >
                            Дата рождения
                        </BaseInput>
                        <BaseInput 
                            :required="true"
                            type="text" 
                            placeholder="email@ya.ru"
                            state-key="email"                             
                        >
                            Email
                        </BaseInput>
                    </div>                                                               
                    <button 
                        :disabled="storeField.isRegestrationBtn"                     
                        class="btn --full" 
                        @click="nextSreen"
                    >                        
                        <span v-if="!storeRequests.loaderBtn">Далее</span>
                        <img v-else class="form__loader" width="36" height="36" src="@/assets/img/icons/loader_black.png" alt="изображение" />
                    </button>
                </div>
            </div>
            
        </div>
    </div>
</template>
<style lang='scss' scoped>
</style>